// extracted by mini-css-extract-plugin
export default {"col":"LotterySlot_col__KYsw9","win":"LotterySlot_win__zzVa9"};